<div class="container-fluid mobile-menu background-light general-white-bg d-flex flex-grow flex-column flex-md-row-reverse d-lg-none small">
  <div class="content">
    <div class="row underlined">
      <div class="col-12">
        <div class="row align-items-center gray3">
          <div class="col-1 icon"><i class='fas fa-search'></i></div>
          <div class="col-10 col-md-11 search">
            <form id="mobile-search">
              <!--<input type="search" name="mobile-search" id="mobile-search-input" class="form-control mobile-search-input small" aria-label="Search Farmers Market..." placeholder="Search Farmers Market...">-->
              <input #searchInput type="text" name="mobile-search" id="mobile-search-input" class="form-control mobile-search-input small" aria-label="Search Farmers Market..." placeholder="Search Farmers Market..."
                     (keyup)="keyUp($event)"
                     [(ngModel)]="searchText"
                     id="member-searchbar">
            </form>
          </div>
        </div>
      </div>
    </div>

    <div [hidden]="!searchText || searchText === ''" class="p-2">
      <app-search></app-search>
    </div>

<!--    <div class="col-12 col-md-12">-->
<!--      <div class="fa fa-shopping-cart"></div>-->
<!--    </div>-->

    <ng-container *ngIf="!searchText || searchText === ''">
      <div class="row underlined" *ngIf="includeLinks">
        <div class="col-6">
          <div><a class="nav-link" href="#" routerLink="/delivery" aria-label="Delivery">Delivery</a></div>
          <div><a class="nav-link" href="#" routerLink="/merchants" aria-label="Merchants">Merchants</a></div>
          <div><a class="nav-link" href="#" routerLink="/visit" aria-label="Visit">Visit</a></div>
          <div><a class="nav-link" href="#" routerLink="/events" aria-label="Events">Events</a></div>
          <div><a class="nav-link" href="#" routerLink="/market-buzz" aria-label="Market Buzz">Market Buzz</a></div>
          <div><a class="nav-link" href="#" routerLink="/store" aria-label="Store">Store</a></div>
        </div>
        <div class="col-6">
          <div><a class="nav-link" href="#" routerLink="/history" aria-label="History">History</a></div>
          <div><a class="nav-link" href="#" (click)="goto('https://www.google.com/maps/place/6333+W+3rd+St,+Los+Angeles,+CA+90036', $event)" aria-label="Directions">Directions</a></div>
          <div><a class="nav-link" href="#" routerLink="/market-office" aria-label="Contact">Contact</a></div>
          <div><a class="nav-link" href="#" routerLink="/faq" aria-label="FAQs">FAQs</a></div>
          <div><a class="nav-link" href="#" routerLink="/visit" fragment="market-map" aria-label="Market Map">Market Map</a></div>
          <div><a class="nav-link" href="#" routerLink="/merchants" [queryParams]="{category: 'All'}" aria-label="Merchants Directory">Directory</a></div>
        </div>
      </div>
      <div class="row underlined address">
        <div class="col-12">
          <div class="row align-items-center flex-nowrap gray3" (click)="goto('https://www.google.com/maps/place/6333+W+3rd+St,+Los+Angeles,+CA+90036', $event)">
            <div class="col-1 icon"><i class='fas fa-map-marker-alt'></i></div>
            <div class="col-11 search">
              6333 W. 3rd St. <br>
              Los Angeles, CA 90036
            </div>
            <div class="icon right d-block d-lg-none"><i class='fas fa-directions'></i></div>
          </div>
        </div>
      </div>
      <div class="row underlined">
        <div class="col-12">

          <div *ngIf="!!visitorMapAndHoursData" class="row align-items-center flex-nowrap gray3">
            <div class="col-1 icon"><i class="fas fa-clock"></i></div>
              <div class="container col-11">
                <div class="row w-100" *ngIf="!!visitorMapAndHoursData.weekdayHours">
                  <div class="col" [innerHTML]=" visitorMapAndHoursData.weekdayHoursText"></div>
                  <div class="col" [innerHTML]="visitorMapAndHoursData.weekdayHours"></div>
                </div>
                <div class="row w-100" *ngIf="!!visitorMapAndHoursData.weekendHours">
                  <div class="col" [innerHTML]="visitorMapAndHoursData.weekendHoursText"></div>
                  <div class="col" [innerHTML]="visitorMapAndHoursData.weekendHours"></div>
                </div>
                <div class="note">NOTE: Some vendors have extended hours.</div>
              </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
